module.exports = __webpack_public_path__ + "img/icon_office-lunch.4ae3877d.svg";